import React from 'react';
import { Typography as MuiTypography } from '@mui/material';

const Typography = (props) => {
  return (
    <MuiTypography {...props} />
  );
};

export default Typography;
